import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

// Reusable cross-page CTA shown before the footer on SAFE Labs pages.
export const SafeLabsCTA = () => (
  <section className="bg-slate-900 text-white" data-testid="safe-labs-cta">
    <div className="max-w-5xl mx-auto px-6 md:px-12 py-16 md:py-20">
      <div className="border-l-2 border-cyan-500 pl-6 md:pl-10">
        <p className="text-xs text-cyan-400 uppercase tracking-[0.2em] font-semibold mb-4">
          Preparing for SAFE Labs?
        </p>
        <h2 className="text-3xl md:text-4xl font-semibold tracking-tight leading-tight mb-5 max-w-2xl">
          Understand Your Readiness Before Verification
        </h2>
        <p className="text-base md:text-lg text-slate-300 leading-relaxed max-w-2xl mb-8">
          The SAFE Verification Readiness Programme identifies your current safeguarding position,
          evidence gaps, priority actions, and practical pathway toward future independent verification.
        </p>
        <Link
          to="/safe-labs/verification-readiness"
          className="inline-flex items-center gap-2 bg-cyan-600 text-white px-8 py-4 text-sm font-bold uppercase tracking-widest hover:bg-cyan-500 transition-colors"
          data-testid="safe-labs-cta-button"
        >
          Explore Verification Readiness <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  </section>
);

export default SafeLabsCTA;
